import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  vehicleTypeList: [],
  vehicleTypeById: {},
  vehicleTypeByCategory: [],

  loading: {
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
    vehicleByCategory: false,
  },
  error: false,
  errorMessage: "",
};

const vehicleTypeSlice = createSlice({
  name: "vehicleType",
  initialState,
  reducers: {
    getVehicleTypeList(state, action) {
      state.vehicleTypeList = action.payload;
      state.loading.read = false;
      state.error = false;
    },
    vehicleTypeById(state, action) {
      state.vehicleTypeById = action.payload;
      state.loading.getById = false;
      state.error = false;
    },
    vehicleTypeByCategory(state, action) {
      state.vehicleTypeByCategory = action.payload;
      state.loading.vehicleByCategory = false;
      state.error = false;
    },
    errorMessages(state, action) {
      state.errorMessage = action.payload;
      state.error = true;
      Object.keys(state.loading).forEach((key) => {
        state.loading[key] = false;
      });
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    setLoading(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getVehicleTypeList,
  vehicleTypeById,
  vehicleTypeByCategory,
  errorMessages,
  setLoading,
  hideErrorMessage,
} = vehicleTypeSlice.actions;

export default vehicleTypeSlice.reducer;
export const vehicleTypeReducer = vehicleTypeSlice.reducer;
